import ListaFacturaDevolucion from "../componentes/ListaFacturasDevolucion.vue";
import FormFacturaDevolucion from "../componentes/FormFacturaDevolucion.vue";

const routes = [
    ...route(`/lista-facturas-devolucion`, ListaFacturaDevolucion ),
    ...route(`/registrar-factura-devolucion`, FormFacturaDevolucion),
];

function route(path, component = Default, meta = {}) {
    return [
        {
            path,
            component,
            meta,
        },
    ];
}

export default routes;
